/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightSeatElement } from "./FlightSeatElement";
import {
  FlightSeatElementFromJSON,
  FlightSeatElementFromJSONTyped,
  FlightSeatElementToJSON,
  FlightSeatElementToJSONTyped,
} from "./FlightSeatElement";

/**
 *
 * @export
 * @interface FlightSeatMap
 */
export interface FlightSeatMap {
  /**
   *
   * @type {number}
   * @memberof FlightSeatMap
   */
  segmentIndex: number;
  /**
   *
   * @type {string}
   * @memberof FlightSeatMap
   */
  segmentLabel: string;
  /**
   *
   * @type {Array<FlightSeatElement>}
   * @memberof FlightSeatMap
   */
  elements: Array<FlightSeatElement>;
}

/**
 * Check if a given object implements the FlightSeatMap interface.
 */
export function instanceOfFlightSeatMap(value: object): value is FlightSeatMap {
  if (!("segmentIndex" in value) || value["segmentIndex"] === undefined)
    return false;
  if (!("segmentLabel" in value) || value["segmentLabel"] === undefined)
    return false;
  if (!("elements" in value) || value["elements"] === undefined) return false;
  return true;
}

export function FlightSeatMapFromJSON(json: any): FlightSeatMap {
  return FlightSeatMapFromJSONTyped(json, false);
}

export function FlightSeatMapFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSeatMap {
  if (json == null) {
    return json;
  }
  return {
    segmentIndex: json["segment_index"],
    segmentLabel: json["segment_label"],
    elements: (json["elements"] as Array<any>).map(FlightSeatElementFromJSON),
  };
}

export function FlightSeatMapToJSON(json: any): FlightSeatMap {
  return FlightSeatMapToJSONTyped(json, false);
}

export function FlightSeatMapToJSONTyped(
  value?: FlightSeatMap | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    segment_index: value["segmentIndex"],
    segment_label: value["segmentLabel"],
    elements: (value["elements"] as Array<any>).map(FlightSeatElementToJSON),
  };
}
